/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { replacePXinStringWithEM, heights, spacing, mediaQuery, pxToEm } from 'utils/styles';



/* ++++++++++ --------------- EXPORT --------------- ++++++++++ */
// FOOTER STYLES
// utliizes utils and CSS-IN-JS (JS objects converted to CSS using a library)
export default {
	header: {
		// parent is inner in content_styles
		width: '100%',
		height: heights.header,
		padding: replacePXinStringWithEM(`0px ${spacing.sides}`), // top and bottom on header and footer
		position: 'absolute',
		top: '0',
		left: '0',
		zIndex: '4',

		// ~~~~ ANIMATION INTRO ~~~~ //
		// moved to app_styles so these only animate once and not every render
		// transform: 'translate3d(0, -100%, 0)', // pull off screen to start
		// animationName: 'slideInDown',
		// animationDelay: '.6s',
		// animationDuration: '.3s',
		// animationFillMode: 'forwards',

		'& .inner': {
			display: 'table', // need to have this here instead of on the footer because IOS safari does not understand absolute tables with a width of 100%
			width: '100%',
			height: '100%'
		},
        '&.large-true':{
            fontSize: '109%'
        }
	},
	group: {
		display: 'table-cell',
		verticalAlign: 'middle'
	},
	left: { textAlign: 'left' },
	right: { textAlign: 'right' },
	// ((((((((((((((( MEDIA QUERIES ))))))))))))))) //
    [mediaQuery.wide]: {
    	left: { fontSize: '105%' },
        right: { fontSize: '105%' }
    },
    [mediaQuery.thin]: {
    	header: { fontSize: '95%' }, // '& .inner': { display: 'flex', flexDirection: 'column' }
    	// group: { flex: '1', textAlign: 'center', display: 'inline-block' },
    	// bullets
    	// left: { order: '2', position: 'relative', top: pxToEm(-2) },
    	// logo
    	// right: { order: '1', paddingTop: pxToEm(7), '& .logo': { backgroundPosition: '50% 50%' } }
    },

    [`@media only screen and (max-width:${pxToEm(400)})`]:{
    header:{
		'&.abTestVersion-QUALIFIED-1, &.abTestVersion-UNLOCKED':{
			display: 'none'
		}
    }
    }
};
